import(/* webpackMode: "eager" */ "/home/runner/work/stepin-tournament-website/stepin-tournament-website/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/stepin-tournament-website/stepin-tournament-website/src/legacy/components/apps/Freeze.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Providers"] */ "/home/runner/work/stepin-tournament-website/stepin-tournament-website/src/legacy/components/apps/Jotai.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/stepin-tournament-website/stepin-tournament-website/src/legacy/components/auth/TabSyncHandler.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/stepin-tournament-website/stepin-tournament-website/src/scss/reset.scss");
